<template>
    <div class="card-container">

        <div class="card">
            <ul class="accordion-list">
                <li v-for="(item, i) in faqList" :key="i" class="accordion-item">
                    <button class="accordion-header" @click="toggle(i)">
                        <span class="accordion-title">{{ item.title }}</span>
                        <svg class="accordion-icon" :class="{ rotated: item.open }" viewBox="0 0 20 20"
                            fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>

                    <transition name="accordion">
                        <div v-show="item.open" class="accordion-content">
                            <br />
                            <span class="accordion-title"
                                style="font-weight: 400; font-size: 18px; color: #FFFFFFCC;">
                                {{ item.listheader }}
                            </span>

                            <!-- If item content is a list -->
                            <ul v-if="Array.isArray(item.description)">
                                <li v-for="(point, j) in item.description" :key="j">
                                    {{ point }}
                                </li>
                            </ul>

                            <span class="accordion-subtitle">{{ item.description }}</span>
                        </div>
                    </transition>
                </li>
            </ul>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import axios from 'axios';

const faqList = ref([])

/* eslint-disable */
const items = ref([
    {
        title: "What are the bookable times for tennis courts?",
        content: "Requests go to line manager first, then HR for final approval.",
        open: false,
    },
    {
        title: "How do I book a tennis court?",
        content: "Requests go to line manager first, then HR for final approval.",
        open: false,
    },
    {
        title: "What types of courts are available?",
        content: [
            "Line manager approval: 1 business day.",
            "HR processing: 1 additional business day.",
        ],
        open: false,
    },
    {
        title: "What are the court booking fees?",
        subtitle: "Courts are booked via your online login and the member booking the court pays the full court fee. You will need to have funds on your online account to book courts.",
        listheader: "All tennis courts are charged at £2 for every 30 minutes booked:",
        content: [
            "30 minutes: £2.00",
            "60 minutes: £4.00",
            "90 minutes: £6.00",
            "120 minutes: £8.00",
        ],
        open: true,
    },
    {
        title: "What is the refund policy?",
        content: [
            "Line manager approval: 1 business day.",
            "HR processing: 1 additional business day.",
        ],
        open: false,
    },
    {
        title: "What other important points should I remember?",
        content: "Requests go to line manager first, then HR for final approval.",
        open: false,
    },
])

// Load FAQ from backend
const faqLists = async () => {
  try {
    const response = await axios.get("/faq_list.php");

    // Ensure each FAQ has an "open" field
    faqList.value = response.data.data.map(item => ({
      ...item,
      open: false
    }));
  } catch (error) {
    alert(error.response ? error.response.data.message : error.message);
    console.error("Error:", error.response ? error.response.data : error.message);
  }
};

onMounted(() => {
  faqLists();
});

// Toggle accordion
function toggle(index) {
  faqList.value[index].open = !faqList.value[index].open;
}
</script>

<style lang="scss" scoped>
.card-container {
    width: 100%;
    background-color: #0C1518;
    border-radius: 20px;
    padding: 60px;
    margin-top: 13rem;
}

.card {
    width: 100%;
    margin: 2rem 0;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #00000033;
    border-radius: 40px;
    border: 1px solid #FFFFFF33;
    padding: 40px 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.accordion-list {
    list-style: none;
    padding: 0;
    width: 100%;
    margin: 0;
}

.accordion-item {
    border-bottom: 1px solid #00000040;
    padding: 12px 0;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-align: left;
}

.accordion-title {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #fff;
    font-size: 18px;
}

.accordion-subtitle {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #FFFFFF66;
    font-size: 18px;
}

.accordion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease;
    color: white;
}

.accordion-icon.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: #fff;
    text-align: left;
}

/* Smooth open/close transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 200px;
    opacity: 1;
}

@media (max-width: 768px) {
    .card-container {
        padding: 10px;
        margin: 0%;
    }

    .card {
        max-width: 100%;
        margin: 1rem auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        border-radius: 40px;
        padding: 10px 20px;
    }
}
</style>
